import { render } from "./RoomGuestCard.vue?vue&type=template&id=a803a970"
import script from "./RoomGuestCard.vue?vue&type=script&lang=js"
export * from "./RoomGuestCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__